import React from 'react';
import { render } from 'react-dom';
import '@here/ref-client-ui/dist/main.css';
import '../../node_modules/font-awesome/scss/font-awesome.scss';
import 'rc-slider/assets/index.css';
import { ConnectedRouter, connectRouter, routerMiddleware } from 'connected-react-router';
import { applyMiddleware, combineReducers, createStore } from 'redux';
import * as data from './state';
import { Route } from 'react-router';
import { createBrowserHistory } from 'history';
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createLogger } from 'redux-logger';
import initGlobalErrors from './utils/globalErrors';
import settingsInitState from './state/settings/default/initState';
import { addTab } from './state/tabs/actions';

import { getDefaultModule } from './state/appSettings';
import { Provider } from 'react-redux';
import App from './views/App';
import refClient from './core/refClient';
import '@here/lui-core/dist/lui-core.min';
import Admin from './views/AdminPanel/Admin';
import ProtectedRoute from './core/ProtectedRoute/ProtectedRoute';
import { persistStore, persistReducer, createTransform } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import storage from 'redux-persist/lib/storage';



// Create expiration transform
const expireTransform = createTransform(
  // Transform state before persisting
  (inboundState, key) => {
    if (key === 'activeUser') {
      return {
        ...inboundState,
        timestamp: new Date().getTime(),
        expiresAt: new Date().getTime() + (24 * 60 * 60 * 1000) // 24 hours
      };
    }
    return inboundState;
  },
  // Transform state after rehydrating
  (outboundState, key) => {
    if (key === 'activeUser' && outboundState.expiresAt) {
      const now = new Date().getTime();
      if (now > outboundState.expiresAt) {
        // Data expired, return initial state
        return { activeUserInfo: null };
      }
      // Remove timestamp/expiry fields from the actual state
      const { timestamp, expiresAt, ...cleanState } = outboundState;
      return cleanState;
    }
    return outboundState;
  },
  // Apply to selectedUser only
  { whitelist: ['activeUser'] }
);

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['activeUser','supportedCountries'], // activeUser & supportedCountries will be persisted
  transforms: [expireTransform],
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  renderRefClient: async (configs, el) => {
    const history = createBrowserHistory();
    const reducer = combineReducers({
      ...data.appReducers,
      router: connectRouter(history),
    });

    const persistedReducer = persistReducer(persistConfig, reducer);
    // Sync dispatched route actions to the history
    const reduxRouterMiddleware = routerMiddleware(history);

    const middlewares = [reduxRouterMiddleware, thunkMiddleware];

    let createStoreWithMd;
    if (process.env.NODE_ENV !== 'production') {
      createStoreWithMd = composeWithDevTools(
        applyMiddleware(...middlewares, createLogger({ collapsed: true }))
      )(createStore);
    } else {
      initGlobalErrors();
      createStoreWithMd = composeWithDevTools(applyMiddleware(...middlewares))(
        createStore
      );
    }

    const store = createStoreWithMd(persistedReducer, {
      settings: { default: settingsInitState(configs) },
    });
    const persistor = persistStore(store);
    store.dispatch(addTab({ title: getDefaultModule(store.getState()) }));
    render(
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ConnectedRouter history={history}>
            <Route exact path="/" component={App} />
            <Route path="/admin" render={() => (
              <ProtectedRoute requireSuperAdmin={true}>
                <Admin />
              </ProtectedRoute>
            )} />
          </ConnectedRouter>
        </PersistGate>
      </Provider>,
      el
    );
  },
  ...refClient,
  loadConfig: refClient.loadConfig,
  loadKeys: refClient.loadKeys,
};
